import { pathBuilder } from 'config/paths/index';

export const root = '/admin/company/polygraphs';
export default pathBuilder(root);
